import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { RfpProfessionalRequiredConditionPossibleGroupTag } from '@/components/modules/pages/rfp/professional/Tag/RfpProfessionalRequiredConditionPossibleGroupTag';
import { RFP_REQUIRED_SUB_CONDITION_SUB_TYPES } from '@/utils/constants/rfp/rfpRequiredSubCondition/subType';
/**
 * 「プロジェクトで求めていること」で利用する言語対応用のタグ
 * @param props
 * @constructor
 */
export const RfpProfessionalRequiredSubConditionSubTypePossibleGroupTag = (props) => {
    const { className = '', subTypes } = props;
    const items = useMemo(() => RFP_REQUIRED_SUB_CONDITION_SUB_TYPES.map((v) => ({
        isPossible: subTypes.includes(v.value),
        label: v.label,
    })), [subTypes]);
    return (_jsx(RfpProfessionalRequiredConditionPossibleGroupTag, { className: className, items: items }));
};
